import { Tooltip } from '@latitude/tooltip';
import type { ReactNode } from 'react';
import { Component } from 'react';

export class SafeTooltip extends Component<
  { text: string; children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { text: string; children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  static getDerivedStateFromError(_: any) {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return this.props.children;
    }
    return (
      <Tooltip text={this.props.text} side="top" align="center">
        {this.props.children}
      </Tooltip>
    );
  }
}
